import { apiClient } from '../lib/api';
import type {
  AuthorizeResponse,
  CalendarEvent,
  CalendarEventCreate,
  CalendarEventDetail,
  CalendarEventUpdate,
  Connection,
} from '../types/integrations';

interface Envelope<T> {
  status: 'success';
  data: T;
}

export const integrationsService = {
  list: () => apiClient.get<Envelope<Connection[]>>('/integrations'),

  startGoogleConnect: () =>
    apiClient.get<Envelope<AuthorizeResponse>>('/integrations/google/authorize'),

  disconnect: (connectionId: string) =>
    apiClient.delete<Envelope<{ id: string }>>(`/integrations/${connectionId}`),

  listEvents: (from: Date, to: Date) =>
    apiClient.get<
      Envelope<{
        connected: boolean;
        connection_status?: string;
        events: CalendarEvent[];
      }>
    >('/integrations/google/calendar/events', {
      params: { from: from.toISOString(), to: to.toISOString() },
    }),

  createEvent: (payload: CalendarEventCreate) =>
    apiClient.post<Envelope<CalendarEventDetail>>(
      '/integrations/google/calendar/events',
      payload
    ),

  getEvent: (eventId: string, calendarId?: string) =>
    apiClient.get<Envelope<CalendarEventDetail>>(
      `/integrations/google/calendar/events/${eventId}`,
      { params: calendarId ? { calendar_id: calendarId } : {} }
    ),

  updateEvent: (eventId: string, patch: CalendarEventUpdate) =>
    apiClient.put<Envelope<CalendarEventDetail>>(
      `/integrations/google/calendar/events/${eventId}`,
      patch
    ),

  deleteEvent: (eventId: string, calendarId?: string) =>
    apiClient.delete<Envelope<{ id: string }>>(
      `/integrations/google/calendar/events/${eventId}`,
      { params: calendarId ? { calendar_id: calendarId } : {} }
    ),
};
